import '@hotwired/turbo-rails'

import 'trix'
import '@rails/actiontext'
import * as ActiveStorage from '@rails/activestorage'
import '@quis-de/fontawesome-pro/js/fontawesome'
import '@quis-de/fontawesome-pro/js/duotone'
// require("channels")

// Stimulus
import './controllers'

/* global Trix */
Trix.config.blockAttributes.heading4 = {
  tagName: 'h4',
  terminal: true,
  breakOnReturn: true
}
Trix.config.blockAttributes.heading5 = {
  tagName: 'h5',
  terminal: true,
  breakOnReturn: true
}

Trix.config.attachments.preview.caption.name = false
Trix.config.attachments.preview.caption.size = false
Trix.config.attachments.file.caption.size = false

Trix.config.toolbar.getDefaultHTML = () => {
  const { lang } = Trix.config

  return `<div class="flex gap-2">
      <span class="join trix-button-group--text-tools" data-trix-button-group="text-tools">
        <button type="button" class="btn join-item" data-trix-attribute="bold" data-trix-key="b" title="${lang.bold}" tabindex="-1">
            <i class="far fa-bold"></i>
        </button>
        <button type="button" class="btn join-item" data-trix-attribute="italic" data-trix-key="i" title="${lang.italic}" tabindex="-1">
            <i class="far fa-italic"></i>
        </button>
        <button type="button" class="btn join-item" data-trix-attribute="strike" title="${lang.strike}" tabindex="-1">
            <i class="far fa-strikethrough"></i>
        </button>
        <button type="button" class="btn join-item" data-trix-attribute="href" data-trix-action="link" data-trix-key="k" title="${lang.link}" tabindex="-1">
            <i class="far fa-link"></i>
        </button>
      </span>

    <span class="join trix-button-group--block-tools" data-trix-button-group="block-tools">
        <button type="button" class="btn join-item" data-trix-attribute="heading4" title="${lang.heading4}" tabindex="-1">
            <i class="far fa-heading"></i>
            <i class="far fa-4 fa-xs"></i>
        </button>
        <button type="button" class="btn join-item" data-trix-attribute="heading5" title="${lang.heading5}" tabindex="-1">
            <i class="far fa-heading"></i>
            <i class="far fa-5 fa-xs"></i>
        </button>
        <button type="button" class="btn join-item" data-trix-attribute="quote" title="${lang.quote}" tabindex="-1">
            <i class="far fa-quote-left"></i>
        </button>
        <button type="button" class="btn join-item" data-trix-attribute="bullet" title="${lang.bullets}" tabindex="-1">
            <i class="far fa-list-ul"></i>
        </button>
        <button type="button" class="btn join-item" data-trix-attribute="number" title="${lang.numbers}" tabindex="-1">
            <i class="far fa-list-ol"></i>
        </button>
        <button type="button" class="btn join-item" data-trix-action="decreaseNestingLevel" title="${lang.outdent}" tabindex="-1">
            <i class="far fa-outdent"></i>
        </button>
        <button type="button" class="btn join-item" data-trix-action="increaseNestingLevel" title="${lang.indent}" tabindex="-1">
            <i class="far fa-indent"></i>
        </button>
      </span>

    <span class="trix-button-group--file-tools" data-trix-button-group="file-tools">
      <button type="button" class="btn" data-trix-action="attachFiles" title="${lang.attachFiles}" tabindex="-1">
              <i class="far fa-paperclip-vertical"></i>
      </button>
    </span>

    <span class="grow"></span>

    <span class="join trix-button-group--history-tools" data-trix-button-group="history-tools">
        <button type="button" class="btn join-item" data-trix-action="undo" data-trix-key="z" title="${lang.undo}" tabindex="-1">
            <i class="far fa-undo"></i>
        </button>
        <button type="button" class="btn join-item" data-trix-action="redo" data-trix-key="shift+z" title="${lang.redo}" tabindex="-1">
            <i class="far fa-redo"></i>
        </button>
      </span>
  </div>

  <div class="trix-dialogs" data-trix-dialogs>
    <div class="absolute menu rounded-box bg-white shadow w-full trix-dialog--link" data-trix-dialog="href" data-trix-dialog-attribute="href">
      <div class="trix-dialog__link-fields">
        <div class="join w-full">
          <input type="url" name="href" class="join-item input grow" placeholder="${lang.urlPlaceholder}"
                 aria-label="${lang.url}" data-trix-validate-href required data-trix-input/>
          <input type="button" class="join-item btn" value="${lang.link}" data-trix-method="setAttribute"/>
          <input type="button" class="join-item btn" value="${lang.unlink}" data-trix-method="removeAttribute"/>
        </div>
      </div>
    </div>
  </div>`
}

ActiveStorage.start()
